<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading">Maximal Metabolic Rate</h5>
        <h6>{{ coeff }} ккал/день</h6>
    </b-alert>
</template>

<script>
import _ from "lodash";

export default {
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            coeff: function () {
                return this.data.out3sfp.bmr.toFixed(0);
            },
            coeffRate: function () {
                return this.data.out.realBiologicalAge - this.data.age;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 41;
                        },
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 23, 41);
                        },
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 13, 23);
                        },
                        variant: 'info',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 5, 13);
                        },
                        variant: 'warning',
                    },
                    {
                        is: function (x) {
                            return x < 5;
                        },
                        variant: 'success',
                    },
                ]
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeffRate);
                });
            }
        }
    }
</script>